import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';

import { type QuoteSegment } from '../constants/quizQuote.const';
import {
  type QuizQuoteFormValues,
  quizQuoteSchema,
} from '../utils/quizQuote.schema';
import { todayISO } from '../utils/quoteDate';

/** 진입 세그먼트에 맞춘 견적 폼 기본값(프리필). */
function getDefaultValues(
  segment: QuoteSegment,
  isTrialEndDiscountMode: boolean,
): QuizQuoteFormValues {
  // 체험 종료 할인은 PRO·개인·1인·1개월에서만 붙는다 → 그 조합으로 프리필한다.
  const isGroup = !isTrialEndDiscountMode && segment === 'group';

  return {
    // plan(Basic/Pro)·plan_type(개인/학교·단체) 모두 사용자 선택.
    // 진입 세그먼트로 플랜 유형만 프리필하고, 단체 최소 조건은 서버 정책 로드 후 보정한다.
    plan: 'pro',
    plan_type: isGroup ? 'group' : 'individual',
    school_name: '',
    account_name: '',
    account_phone: '',
    account_email: '',
    user_count: 1,
    term: 1,
    start_date: todayISO(),
    annotation: '',
    consent: false,
  };
}

/** 견적 폼 인스턴스 — 스키마 resolver + 세그먼트 기본값. */
export function useQuizQuoteForm(
  segment: QuoteSegment,
  isTrialEndDiscountMode = false,
) {
  return useForm<QuizQuoteFormValues>({
    resolver: zodResolver(quizQuoteSchema),
    defaultValues: getDefaultValues(segment, isTrialEndDiscountMode),
    mode: 'onTouched',
  });
}
